import React, { useEffect, useState } from 'react';
import { NumberField } from '@scale/shared/types/params/textcollection';
import { useLLMHelper } from 'react-scale/dashboard.scale.com/contexts/LLMHelperContext';
import CustomTextField from 'react-scale/components/scalers/tasks/textcollection/CustomTextField';
import { Controller } from 'react-hook-form';

interface NumberFieldSectionProps {
  field: NumberField;
  disabled?: boolean;
}

export default function NumberFieldSection(props: NumberFieldSectionProps) {
  const onWheel = (e: $FIXME) => {
    e.target.blur();
  };

  const llmHelper = useLLMHelper();
  const [aiAssistant, setAiAssistant] = useState<string>('');
  const [aiAssistantLoading, setAiAssistantLoading] = useState<boolean>(false);
  useEffect(() => {
    if (
      llmHelper.aiAssistantEnabled &&
      Object.keys(llmHelper.aiAssistantPrompts).includes(props.field.field_id)
    ) {
      (async () => {
        try {
          setAiAssistantLoading(true);
          const content = await llmHelper.getAiAssistantResponse(props.field.field_id);
          if (content) setAiAssistant(content);
        } finally {
          setAiAssistantLoading(false);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [llmHelper.aiAssistantEnabled, llmHelper.aiAssistantPrompts, props.field.field_id]);

  const requiredStr = props.field.required ? ' *' : '';
  const title = `${props.field.title}${requiredStr}`;

  return (
    <>
      {(!!aiAssistant.length || aiAssistantLoading) && (
        <div
          style={{
            marginBottom: 8,
            padding: 8,
            whiteSpace: 'pre-wrap',
            backgroundColor: 'rgba(144, 202, 249, .2)',
            borderRadius: 8,
          }}
        >
          {aiAssistantLoading && !aiAssistant.length
            ? 'AI assistant evaluation is loading...'
            : `The AI assistant suggests: ${aiAssistant}`}
        </div>
      )}
      <Controller
        name={props.field.field_id}
        defaultValue={'0'}
        render={({ field, fieldState }) => (
          <CustomTextField
            fieldId={props.field.field_id}
            disabled={props.disabled}
            setIndexValue={(_, value) => {
              field.onChange(value);
            }}
            type="number"
            index={field.value}
            value={field.value}
            title={title}
            description={props.field.description}
            hint={props.field.hint || props.field.instruction}
            shouldAutoComplete={false}
            onBlur={() => {
              field.onBlur();
            }}
            errorText={fieldState.error?.message}
            onWheel={onWheel}
            rubric={props.field.rubric}
          />
        )}
      />
    </>
  );
}
